import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { TagDetailPage } from '@/features/taxonomy/components/taxonomy-detail-page';

function TagRoute(): ReactNode {
  const { slug } = Route.useParams();
  return <TagDetailPage slug={slug} />;
}

export const Route = createFileRoute('/tags/$slug')({
  component: TagRoute,
});
